import React, { useEffect, useState } from 'react';
import SocialLinks from '../SocialLinks';

import supabase from 'sdk/api';
import useIsAuth from 'sdk/hooks/useIsAuth';
import styles from './SignIn.module.scss';
import Button from 'components/shared/Button';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as IconEye1 } from 'images/pass-hidden.svg';
import { ReactComponent as IconEye2 } from 'images/eye2.svg';

function PhoneOrEmail() {
  const navigate = useNavigate();
  const [login, setLogin] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [isPassVisible, setIsPassVisisble] = useState<boolean>(false);
  const [errorLogin, setErrorLogin] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const {
    data: { isAuth },
  } = useIsAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(login);

    let result;
    if (isEmail) {
      result = await supabase.auth.signInWithPassword({
        email: login,
        password: password,
      });
    } else {
      result = await supabase.auth.signInWithPassword({
        phone: login,
        password: password,
      });
    }

    const { error } = result;

    if (error) {
      setErrorLogin('Check the correctness of your login or password');
      setIsLoading(false);
      return;
    }

    window.location.href = '/feed';
  };

  useEffect(() => {
    if (login && password) {
      setErrorLogin('');
    }
  }, [login, password]);

  return (
    <>
      <form className={styles.phoneView} onSubmit={handleSubmit}>
        <div className={styles.phoneView__inputs}>
          <div className={styles.fields_field}>
            <input
              type="text"
              placeholder="Your phone or email"
              value={login}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLogin(e.target.value)}
            />
          </div>
          <div
            className={styles.fields_field}
            style={{
              border: errorLogin ? '1px solid #FF3B30' : '1px solid#01010180',
            }}
          >
            <input
              type={isPassVisible ? 'text' : 'password'}
              placeholder="Password"
              value={password}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
            />
            {isPassVisible ? (
              <IconEye2 onClick={() => setIsPassVisisble(!isPassVisible)} />
            ) : (
              <IconEye1 onClick={() => setIsPassVisisble(!isPassVisible)} />
            )}
          </div>
        </div>
        {errorLogin && <div className={styles.errorLogin}>{errorLogin}</div>}

        <div className={styles.forgotPassword} onClick={() => navigate('/password-reset/email')}>
          Forgot your password?
        </div>
        <Button
          type="submit"
          wide
          darkGreen
          disabled={!login || !password || isLoading}
          style={{
            marginTop: '20px',
          }}
          loading={isLoading}
        >
          Next
        </Button>

        <div className={styles.or}>or</div>
        <SocialLinks />
      </form>

    </>
  );
}

export default PhoneOrEmail;
